import { render, staticRenderFns } from "./puestos-trabajo.vue?vue&type=template&id=61d88b11&scoped=true"
import script from "./puestos-trabajo.vue?vue&type=script&lang=js"
export * from "./puestos-trabajo.vue?vue&type=script&lang=js"
import style0 from "./puestos-trabajo.vue?vue&type=style&index=0&id=61d88b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d88b11",
  null
  
)

export default component.exports